export default {
  title: 'Recibo impresso',
  form: {
    is_service_fee_hidden_on_receipt: {
      label: 'Ocultar taxa de serviço no recibo',
    },
    is_price_section_hidden_on_receipt: {
      label: 'Ocultar secção de preços no recibo',
    },
    is_modifier_group_hidden_on_receipt: {
      label: 'Ocultar nomes dos grupos de modificadores no recibo',
    },
  },
  buttons: {
    save: 'Guardar',
  },
  toasts: {
    failed_to_save_changes: 'Falha ao guardar alterações',
    changes_got_saved: 'Alterações guardadas',
  },
};
